import { useEffect } from "react";
import "./App.css";
import { useAppContext } from "./AppContext";
import HomePage from "./HomePage";
import MarketingKit from "./components/MarketingKit";
import DownloadPage from "./components/DownloadPage";
import DownloadLeadsPage from "./components/DownloadLeadsPage";
import EmailCSV from "./components/EmailCSV";
import LandingPage from "./components/LandingPage";
import { Routes, Route } from "react-router-dom";

function App() {
  const { setClientSecret, buyNow, setLoadingHeader, selectedPrice, billingFrequency } = useAppContext();

  useEffect(() => {
    if (buyNow === "payment") {
      (async () => {
        try {
          setLoadingHeader(true);
          const apiBase = "https://app.commercialcleaningleadsforyou.com";
          const response = await fetch(
            `${apiBase}/api/create-payment-intent-newBusiness`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                amount: selectedPrice || 19900,
                currency: "usd",
                billingFrequency,
              }),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();
          console.log("Response received:", {
            hasClientSecret: !!data.clientSecret,
          });

          if (!data.clientSecret) {
            throw new Error("No client secret received");
          }

          setClientSecret(data.clientSecret);
        } catch (err) {
          console.error("Error:", err);
        } finally {
          setLoadingHeader(false);
        }
      })();
    }
  }, [buyNow, selectedPrice]);

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/landing" element={<HomePage />} />
      <Route path="/marketingkit" element={<MarketingKit />} />
      <Route path="/download" element={<DownloadLeadsPage />} />
      <Route path="/thank-you" element={<DownloadPage />} />
      <Route path="/downloadcsv/*" element={<EmailCSV />} />
    </Routes>
  );
}

export default App;
